import { InDevelopment } from "../../components/common/InDevelopment";

export default function SuppliersPage() {
  return <InDevelopment resourceName="Постачальники" />;
}
